import { getSessionForAccessInfo, checkGraphResponse } from "./GraphMain";
import { accessInfoType } from "../utils/classInfos";
import { getWorksheetIdFromAddress, getWorksheetUrlSection } from "./helper";
import { getLocalCellNameFromAddress } from "../utils/helperExcel";

export async function getCellAreaInfo(
  accessInfo: accessInfoType,
  address: string,
) {
  if (!address) return;
  const sessionInfo  = await getSessionForAccessInfo(accessInfo);
  // check the info
  if (!sessionInfo || !sessionInfo.sessionId) return null;
  const {client, sessionId, fileUrl} = sessionInfo;

  // get the available worksheets
  let worksheetsUrl = fileUrl + "/workbook/worksheets?$select=name,id";
  const resWorksheets = await client
    .api(worksheetsUrl)
    .header("workbook-session-id", sessionId)
    .get();

  let workSheets = resWorksheets?.value;
  let cellAddress = address.replaceAll("{", "").replaceAll("}", "").replaceAll("$", "");
  // get the worksheet ID
  let worksheetId = "";
  if (workSheets) {
    worksheetId = getWorksheetIdFromAddress(cellAddress, workSheets);
  }
  // get the graph url
  let localAddress = getLocalCellNameFromAddress(cellAddress);

  const addressUrl = fileUrl + "/workbook/"+getWorksheetUrlSection(worksheetId)+"/range(address='"+localAddress+"')?$select=values,text,formulas,numberFormat,cellCount,rowCount,address";
  
  const range = await client
    .api(addressUrl)
    .header("workbook-session-id", sessionId)
    .get();

  checkGraphResponse(range, "getCellAreaInfo");
  if (range) {
    range.worksheetId = worksheetId;
  }
  
  // get the app info
  let appInfo = null;

  return { addressId: cellAddress, range, appInfo, accessInfo };
}

